import { render, staticRenderFns } from "./RepairViewRepairCommentAndSign.vue?vue&type=template&id=7b363b7f"
import script from "./RepairViewRepairCommentAndSign.vue?vue&type=script&lang=js"
export * from "./RepairViewRepairCommentAndSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports